import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile-header',
  templateUrl: './profile-header.component.html',
  styleUrls: ['./profile-header.component.scss']
})
export class ProfileHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  onNavigateToMyContest() {
    let initialMyContestPaginationvalues = { page: 1, limit: 10, tab: 0 }
    window.localStorage.setItem('my-contest-pagination',JSON.stringify(initialMyContestPaginationvalues));
  }

}
